var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgO(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41.7 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.15 52-8.15-8.22v-31.12l12.64-12.66h20.84l8.22 8.16v31.12l-12.7 12.72zm12.75-18.79v-14.48h-.1v14.45z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40.6 8.63-7.6-7.53h-19.89l-12 12v30.21l7.51 7.59h19.88l12.1-12.09zm-19.35 9 .75.64v16.13h-1.61l-.69-.73v-16.07z",
    className: "cjd-stroke",
    fill: "#8089a2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.72 9.1 6.87-6.91h18.94l6.87 6.91v29.24l-6.87 6.86h-18.94l-6.87-6.86zm20.86 4.19-1.34-1.4h-6.3l-1.4 1.4v20.86l1.4 1.34h6.3l1.34-1.34z",
    className: "cjd-fill",
    fill: "#f9fbfe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgO);
export default __webpack_public_path__ + "static/media/o.97c08cb622e3d016069f161059c91bbd.svg";
export { ForwardRef as ReactComponent };